import { DebitCardTransactionUpdate_onDebitCardTransactionUpdate as DebitCardTransactionUpdate } from 'types/gql-types/DebitCardTransactionUpdate'
import { GetDebitCardTransactions_getDebitCardTransactionsV2_transactions_merchant as MerchantData } from 'types/gql-types/GetDebitCardTransactions'

import { DebitCardTransaction } from '../../TransactionDrawer'

const BASIC_MERCHANT_DETAILS_KEYS = ['id', 'name', 'icon']

type MerchantBasicDetails = Pick<MerchantData, 'id' | 'name' | 'icon'>

type TransactionOrUpdate = DebitCardTransaction | DebitCardTransactionUpdate

type PartialTransactionOrUpdate =
  | Partial<DebitCardTransaction>
  | Partial<DebitCardTransactionUpdate>

const getHasMerchantDetails = (
  transactionOrUpdate: TransactionOrUpdate | PartialTransactionOrUpdate
) => {
  return !Object.keys(transactionOrUpdate.merchant || {}).every((key) =>
    BASIC_MERCHANT_DETAILS_KEYS.includes(key)
  )
}

export const getIsADebitCardTransaction = (
  transactionOrUpdate: TransactionOrUpdate | PartialTransactionOrUpdate
): transactionOrUpdate is
  | DebitCardTransaction
  | Partial<DebitCardTransaction> => {
  return (
    getHasMerchantDetails(transactionOrUpdate) ||
    transactionOrUpdate.merchant === null
  )
}

export const padWithNulls = (merchant: MerchantBasicDetails): MerchantData => ({
  __typename: 'MerchantDetails',
  id: merchant.id,
  name: merchant.name,
  icon: merchant.icon,
  address: null,
  hours: null,
  phone: null,
  email: null,
  url: null,
  abn: null,
  location: null,
  locationAccuracy: null,
})
